import { FaRegCheckCircle } from "react-icons/fa";
import "../styles/ai-animation-page.css";

const sessions = [
  {
    title: "Buổi 1: Làm quen với phim hoạt hình và VEO3",
    content: [
      "Xem mẫu phim hoạt hình nổi bật (do trẻ em tạo)",
      "Giới thiệu VEO3: giao diện, chức năng cơ bản",
      "Trải nghiệm nhanh: chọn mẫu nhân vật và chạy thử một đoạn hoạt hình",
    ],
  },
  {
    title: "Buổi 2: Kể chuyện bằng hình ảnh",
    content: [
      "Hiểu cấu trúc câu chuyện (Mở đầu – Vấn đề – Giải quyết)",
      "Hướng dẫn tạo kịch bản đơn giản bằng hình (storyboard)",
      "Thực hành: vẽ hoặc chọn ảnh minh họa cho cốt truyện",
    ],
  },
  {
    title: "Buổi 3: Tạo nhân vật với VEO3",
    content: [
      "Chọn mẫu nhân vật có sẵn trong thư viện",
      "Tùy chỉnh nhân vật: tóc, quần áo, biểu cảm, màu sắc",
      "Thực hành: tạo một nhân vật chính cho câu chuyện của mình",
    ],
  },
  {
    title: "Buổi 4: Tạo bối cảnh hoạt hình",
    content: [
      "Giới thiệu thư viện bối cảnh VEO3 (trường học, rừng, vũ trụ…)",
      "Hướng dẫn tạo khung cảnh theo từng đoạn truyện",
      "Gợi ý: phối cảnh – ánh sáng – đối tượng nền",
    ],
  },
  {
    title: "Buổi 5: Gán chuyển động và hành động",
    content: [
      "Các dạng chuyển động có sẵn trong VEO3",
      "Gán hành động cho nhân vật: đi, chạy, cười, giận…",
      "Thực hành: tạo một cảnh có nhân vật di chuyển và tương tác",
    ],
  },
  {
    title: "Buổi 6: Lồng tiếng – chèn thoại",
    content: [
      "Hướng dẫn ghi âm giọng nói trực tiếp trong VEO3",
      "Dùng AI voice nếu học sinh chưa muốn thu âm",
      "Thực hành: thêm lời thoại vào cảnh đã làm",
    ],
  },
  {
    title: "Buổi 7: Âm thanh và hiệu ứng",
    content: [
      "Chọn nhạc nền phù hợp",
      "Gán hiệu ứng âm thanh (tiếng mưa, xe cộ, tiếng động vật...)",
      "Thực hành: chỉnh âm lượng, thời gian bắt đầu/kết thúc",
    ],
  },
  {
    title: "Buổi 8: Dựng đoạn phim ngắn đầu tiên",
    content: [
      "Gộp các cảnh đã làm thành một đoạn ngắn (30–60s)",
      "Thêm hiệu ứng chuyển cảnh",
      "Xem và nhận xét chéo giữa các bạn",
    ],
  },
  {
    title: "Buổi 9–12: Làm phim theo nhóm (dự án chính)",
    content: [
      "Chia nhóm – chọn đề tài",
      "Phân chia nhiệm vụ: người viết truyện, tạo nhân vật, dựng cảnh, thu âm...",
      "Thực hành từng bước với VEO3 để hoàn thiện phim nhóm",
    ],
  },
  {
    title: "Buổi 13: Chỉnh sửa và hoàn thiện",
    content: [
      "Kiểm tra lỗi kỹ thuật (âm thanh, chuyển động, thoại...)",
      "Tinh chỉnh độ dài, hiệu ứng, logo nhóm",
      "Xuất bản phim (MP4 hoặc đăng tải theo link riêng)",
    ],
  },
  {
    title: "Buổi 14: Luyện thuyết trình – chuẩn bị công chiếu",
    content: [
      "Hướng dẫn cách thuyết trình: giới thiệu phim – nhân vật – quá trình làm",
      "Luyện nói trước lớp",
      "Góp ý và điều chỉnh nội dung trình bày",
    ],
  },
  {
    title: "Buổi 15: Công chiếu & tổng kết",
    content: [
      "Chiếu phim của từng nhóm/lớp",
      "Nhận xét – khen thưởng – bình chọn phim xuất sắc",
      "Trao giấy chứng nhận & phần quà sáng tạo",
      'Tổng kết: "Bạn học được gì từ VEO3 và AI?"',
    ],
  },
];
const extras = [
  "🖌️ Làm quen với storytelling, nhân vật và hoạt hình cơ bản",
  "💡 Học cách sử dụng công cụ VEO3 để tạo phim hoạt hình",
  "🎬 Tự tay sáng tạo và hoàn thiện một bộ phim hoạt hình cá nhân hoặc theo nhóm",
];

const isOdd = extras.length % 2 !== 0;

const AiAnimationPage = () => {
  return (
    <div className="ai-animation-bg">
      <div className="ai-animation">
        <div className="ai-animation__intro">
          <h1 className="ai-animation__title">
            Sáng tạo phim hoạt hình với A.I
          </h1>
          <p className="ai-animation__desc">
            Khóa học cung cấp kiến thức nền tảng về storytelling, nhân vật và
            sản xuất phim hoạt hình bằng A.I thông qua công cụ VEO3. Kết thúc
            khóa, học viên có thể tự tay hoàn thiện một bộ phim hoạt hình ngắn.
          </p>
          <p className="ai-animation__meta">
            <strong>Thời lượng:</strong> 15 buổi (mỗi buổi 2 giờ) |{" "}
            <strong>Đối tượng:</strong> Học sinh cấp 1 & 2
          </p>
        </div>
        <div className="ai-animation__extras">
          <h3 className="ai-animation__extras-title">Mục tiêu khóa học</h3>
          <ul
            className={`ai-animation__extras-list ${
              isOdd ? "center-last" : ""
            }`}
          >
            {extras.map((item, idx) => (
              <li key={idx}>
                <span className="emoji">{item.slice(0, 2)}</span>
                {item.slice(2).trim()}
              </li>
            ))}
          </ul>
        </div>
        <h2 className="ai-animation__section-title"> Lộ trình khóa học</h2>
        <div className="ai-animation__sessions">
          {sessions.map((session, idx) => (
            <div
              className="ai-animation__session"
              key={idx}
            >
              <h3 className="ai-animation__session-title">{session.title}</h3>
              <ul className="ai-animation__session-list">
                {session.content.map((item, i) => (
                  <li
                    className="ai-animation__session-item"
                    key={i}
                  >
                    <FaRegCheckCircle className="ai-animation__icon" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="ai-animation__extras">
          <h3 className="ai-animation__extras-title">
            Tài liệu & hoạt động kèm theo
          </h3>
          <ul className="ai-animation__extras-list">
            <li>
              <span className="emoji">📘</span> Tài liệu hướng dẫn sử dụng VEO3
              cho trẻ em (in màu)
            </li>
            <li>
              <span className="emoji">🧠</span> Phiếu tự đánh giá cảm xúc sau
              mỗi buổi
            </li>
            <li>
              <span className="emoji">🎲</span> Mini game sáng tạo (thiết kế
              nhân vật, đoán phim qua biểu cảm,...)
            </li>
            <li>
              <span className="emoji">🎓</span> Chứng nhận cuối khóa
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AiAnimationPage;
